<button (click)="copyToClipboard();" title="Copy value">
    <mat-icon>content_copy</mat-icon>
</button>